import RootModel from './root';

const Workflow = new RootModel({
	path: 'workflows',
});

export default Workflow;
